import { Component, OnInit, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslatePipe } from '@ngx-translate/core';
import { JjamesButtonComponent } from 'shared-lib';
import { BackfillLongTermParkerPoolCapsResult, ParkingRightMaintenanceService, ParkingSpaceDto } from '../../../api/gen';
import { describeHttpError } from '../../hotline/http-error';

export interface PoolCapBackfillDialogData {
  parkingSpace: ParkingSpaceDto;
}

/**
 * Links the space's uncapped long-term rights to their owner's parker pool config and forces every
 * config onto the space's cars-inside cap (Suppliers skipped).
 *
 * Opens straight into a dry run — the backend writes nothing until `apply` — so the operator sees the
 * counts before committing. Closes with `true` once applied, so the list reloads.
 */
@Component({
  selector: 'app-pool-cap-backfill-dialog',
  imports: [MatDialogModule, MatIconModule, MatProgressSpinnerModule, JjamesButtonComponent, TranslatePipe],
  templateUrl: './pool-cap-backfill-dialog.component.html'
})
export class PoolCapBackfillDialogComponent implements OnInit {
  readonly data = inject<PoolCapBackfillDialogData>(MAT_DIALOG_DATA);
  private dialogRef = inject(MatDialogRef<PoolCapBackfillDialogComponent>);
  private maintenanceService = inject(ParkingRightMaintenanceService);

  result = signal<BackfillLongTermParkerPoolCapsResult | null>(null);
  error = signal<string | null>(null);
  isLoading = signal(false);

  ngOnInit(): void {
    this.run(false);
  }

  apply(): void {
    this.run(true);
  }

  close(): void {
    this.dialogRef.close(this.result()?.applied ?? false);
  }

  private run(apply: boolean): void {
    const spaceId = this.data.parkingSpace.id;
    if (!spaceId) return;

    this.isLoading.set(true);
    this.error.set(null);
    this.maintenanceService.parkingrightsMaintenanceLongTermPoolCapsBackfillPost(spaceId, apply).subscribe({
      next: (result) => {
        this.result.set(result);
        this.isLoading.set(false);
      },
      error: (e) => {
        this.error.set(describeHttpError(e));
        this.isLoading.set(false);
      }
    });
  }
}
